module.exports = __webpack_public_path__ + "img/mathsmith-logo-full-color-rgb.742ad9c2.svg";